import { IconAlertTriangleFilled, IconArrowUpRight } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { generatePath } from "react-router";
import { useProjectBySiteId } from "../../../../../hooks/useProjectBySiteId";
import { MantineActionLinkCell } from "../../../../../mantine/mrt/components/cell/MantineActionLinkCell/MantineActionLinkCell";
import { MantineIconCell } from "../../../../../mantine/mrt/components/cell/MantineIconCell";
import { ROUTES } from "../../../../../routes";
import { ObjectUrlName } from "../../../../../utils/enums";
import { COMPONENTS_PANEL_ID } from "../../../../StructureView/ComponentsPanel/ComponentsPanel";

interface RequiredGenerationShareLinkCellProps {
  siteId: number | string | null | undefined;
  renderedCellValue: ReactNode;
  missingValueText: string;
  tooltip: string;
}

function hasRenderedValue(renderedCellValue: ReactNode): boolean {
  if (renderedCellValue === null || renderedCellValue === undefined) {
    return false;
  }

  if (typeof renderedCellValue === "string") {
    return renderedCellValue.trim().length > 0;
  }

  return true;
}

function RequiredGenerationShareLinkCell({
  siteId,
  renderedCellValue,
  missingValueText,
  tooltip
}: RequiredGenerationShareLinkCellProps) {
  const siteIdNumber = Number(siteId);
  const hasSiteId =
    siteId !== null &&
    siteId !== undefined &&
    siteId !== "" &&
    !Number.isNaN(siteIdNumber);

  const { data } = useProjectBySiteId({
    options: {
      enabled: hasSiteId
    },
    siteId: siteIdNumber
  });

  const projectId = data?.id;

  const displayValue = hasRenderedValue(renderedCellValue) ? (
    renderedCellValue
  ) : (
    <MantineIconCell
      iconColor="var(--mantine-color-warning-filled)"
      IconComponent={IconAlertTriangleFilled}
      renderedCellValue={missingValueText}
    />
  );

  if (!projectId || !hasSiteId) {
    return <>{displayValue}</>;
  }

  const to =
    generatePath(ROUTES.siteComponentPage, {
      projectId,
      siteId: String(siteId),
      objectUrlName: ObjectUrlName.Weightings,
      componentId: "" // No specific component, just open the tab
    }) + `#${COMPONENTS_PANEL_ID}`;

  return (
    <MantineActionLinkCell
      IconComponent={IconArrowUpRight}
      renderedCellValue={displayValue}
      to={to}
      tooltip={tooltip}
    />
  );
}

export { RequiredGenerationShareLinkCell };
